export default __webpack_public_path__ + "static/media/Potion of Dexterity (4h).2fa93b6e.jpg";